"use strict";

var _slicedToArray = require("/tmp/caradvise-production/35/caradvise/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGeolocated = useGeolocated;

var react_1 = require("react");
/**
 * Hook abstracting away the interaction with the Geolocation API.
 * @param config - the configuration to use
 */


function useGeolocated() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$positionOptio = config.positionOptions,
      positionOptions = _config$positionOptio === void 0 ? {
    enableHighAccuracy: true,
    maximumAge: 0,
    timeout: Infinity
  } : _config$positionOptio,
      _config$isOptimisticG = config.isOptimisticGeolocationEnabled,
      isOptimisticGeolocationEnabled = _config$isOptimisticG === void 0 ? true : _config$isOptimisticG,
      _config$userDecisionT = config.userDecisionTimeout,
      userDecisionTimeout = _config$userDecisionT === void 0 ? undefined : _config$userDecisionT,
      _config$suppressLocat = config.suppressLocationOnMount,
      suppressLocationOnMount = _config$suppressLocat === void 0 ? false : _config$suppressLocat,
      _config$watchPosition = config.watchPosition,
      watchPosition = _config$watchPosition === void 0 ? false : _config$watchPosition,
      _config$geolocationPr = config.geolocationProvider,
      geolocationProvider = _config$geolocationPr === void 0 ? typeof navigator !== "undefined" ? navigator.geolocation : undefined : _config$geolocationPr,
      _config$watchLocation = config.watchLocationPermissionChange,
      watchLocationPermissionChange = _config$watchLocation === void 0 ? false : _config$watchLocation,
      onError = config.onError,
      onSuccess = config.onSuccess;
  var userDecisionTimeoutId = (0, react_1.useRef)(0);
  var isCurrentlyMounted = (0, react_1.useRef)(true);
  var watchId = (0, react_1.useRef)(0);

  var _ref = (0, react_1.useState)(isOptimisticGeolocationEnabled),
      _ref2 = _slicedToArray(_ref, 2),
      isGeolocationEnabled = _ref2[0],
      setIsGeolocationEnabled = _ref2[1];

  var _ref3 = (0, react_1.useState)(),
      _ref4 = _slicedToArray(_ref3, 2),
      coords = _ref4[0],
      setCoords = _ref4[1];

  var _ref5 = (0, react_1.useState)(),
      _ref6 = _slicedToArray(_ref5, 2),
      timestamp = _ref6[0],
      setTimestamp = _ref6[1];

  var _ref7 = (0, react_1.useState)(),
      _ref8 = _slicedToArray(_ref7, 2),
      positionError = _ref8[0],
      setPositionError = _ref8[1];

  var _ref9 = (0, react_1.useState)(),
      _ref10 = _slicedToArray(_ref9, 2),
      permissionState = _ref10[0],
      setPermissionState = _ref10[1];

  var cancelUserDecisionTimeout = (0, react_1.useCallback)(function () {
    if (userDecisionTimeoutId.current) {
      window.clearTimeout(userDecisionTimeoutId.current);
    }
  }, []);
  var handlePositionError = (0, react_1.useCallback)(function (error) {
    cancelUserDecisionTimeout();

    if (isCurrentlyMounted.current) {
      setCoords(function () {
        return undefined;
      });
      setIsGeolocationEnabled(false);
      setPositionError(error);
    }

    onError === null || onError === void 0 ? void 0 : onError(error);
  }, [onError, cancelUserDecisionTimeout]);
  var handlePositionSuccess = (0, react_1.useCallback)(function (position) {
    cancelUserDecisionTimeout();

    if (isCurrentlyMounted.current) {
      setCoords(position.coords);
      setTimestamp(position.timestamp);
      setIsGeolocationEnabled(true);
      setPositionError(function () {
        return undefined;
      });
    }

    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(position);
  }, [onSuccess, cancelUserDecisionTimeout]);
  var getPosition = (0, react_1.useCallback)(function () {
    if (!geolocationProvider || !geolocationProvider.getCurrentPosition || !geolocationProvider.watchPosition) {
      throw new Error("The provided geolocation provider is invalid");
    }

    if (userDecisionTimeout) {
      userDecisionTimeoutId.current = window.setTimeout(function () {
        handlePositionError();
      }, userDecisionTimeout);
    }

    if (watchPosition) {
      watchId.current = geolocationProvider.watchPosition(handlePositionSuccess, handlePositionError, positionOptions);
    } else {
      geolocationProvider.getCurrentPosition(handlePositionSuccess, handlePositionError, positionOptions);
    }
  }, [geolocationProvider, watchPosition, userDecisionTimeout, handlePositionError, handlePositionSuccess, positionOptions]);
  (0, react_1.useEffect)(function () {
    var permission;

    if (watchLocationPermissionChange && geolocationProvider && "permissions" in navigator) {
      navigator.permissions.query({
        name: "geolocation"
      }).then(function (result) {
        permission = result;

        permission.onchange = function () {
          setPermissionState(permission.state);
        };
      }).catch(function (e) {
        console.error("Error updating the permissions", e);
      });
    }

    return function () {
      if (permission) {
        permission.onchange = null;
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  (0, react_1.useEffect)(function () {
    if (!suppressLocationOnMount) {
      getPosition();
    }

    return function () {
      cancelUserDecisionTimeout();

      if (watchPosition && watchId.current) {
        geolocationProvider === null || geolocationProvider === void 0 ? void 0 : geolocationProvider.clearWatch(watchId.current);
      }
    };
  }, [permissionState]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    getPosition: getPosition,
    coords: coords,
    timestamp: timestamp,
    isGeolocationEnabled: isGeolocationEnabled,
    isGeolocationAvailable: Boolean(geolocationProvider),
    positionError: positionError
  };
}